import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { RicercaAnagraficheFormComponent } from '../../../form/ricerca-anagrafiche-form.component';
import { Parte } from '../../../models/parte';
import { SezioneAltreParti } from '../../../models/sezioni/sezione-altre-parti';
import { ParteAnagraficaAddComponent } from '../parte-anagrafica-update/parte-anagrafica-add.component';
import { AltrePartiAssociativaAddComponent } from './altre-parti-associativa-add.component';

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
  selector: 'div [altre-parti-mod-add]',
  templateUrl: 'altre-parti-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class AltrePartiModAggiungi {
  haveNewAnagrafica: boolean = false;
  viewSearchMask: boolean = true;
  addAltraParteUrl: string;
  idSezione: string;
  idFascicolo: string;
  urlSezioneControparti: string;
  idSezioneControparti: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Input() titleSection: string = 'altre parti';
  @Output() onReturn: EventEmitter<SezioneAltreParti> = new EventEmitter<SezioneAltreParti>();
  @ViewChild('formAddAnagrafica') modaleAnagrafica: ParteAnagraficaAddComponent;
  @ViewChild('formAddAssociativaAnagrafica') modaleAssociativaAnagrafica: AltrePartiAssociativaAddComponent;
  @ViewChild('formRicercaParte') modaleRicerca: RicercaAnagraficheFormComponent<Parte>;
  @ViewChild('formAddAssociativaRicerca') modaleAssociativaRicerca: AltrePartiAssociativaAddComponent;

  inizializza(urlAggiungiInAnagrafica: string, addAltraParteUrl, idSezione, idFascicolo, urlSezioneControparti: string, idSezioneControparti: string, tipoPratica, idTipoFascicolo) {
    this.addAltraParteUrl = addAltraParteUrl;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.urlSezioneControparti = urlSezioneControparti;
    this.idSezioneControparti = idSezioneControparti;
    this.modaleAnagrafica.inizializza(urlAggiungiInAnagrafica, tipoPratica, idTipoFascicolo);
    // this.modaleAnagrafica.inizializza(urlAggiungiInAnagrafica, tipoPratica);
    this.modaleRicerca.inizializza(ServicePathsSettings.URL_SEARCH_PARTE, true);
    $('a[href="#tabcontent7"]').tab('show');
    openModal('modalmodaggiungi');
  }

  createForm() {
    this.haveNewAnagrafica = false;
    this.viewSearchMask = true;
    $('a[href="#tabcontent7"]').tab('show');
    if (this.modaleRicerca) {
      this.modaleRicerca.setTextEmpty();
      this.modaleRicerca.resetResults();
    }

    this.modaleAnagrafica.createForm();

    // this.modaleAnagrafica.createForm();
  }

  newAnagrafica(parte: Parte) {
    this.haveNewAnagrafica = true;
    this.modaleAssociativaAnagrafica.inizializza(parte, this.addAltraParteUrl, this.idSezione, this.idFascicolo, this.urlSezioneControparti, this.idSezioneControparti);

  }

  manageModal(sezione: SezioneAltreParti) {
      this.createForm();
      closeModal('modalmodaggiungi');
      this.onReturn.emit(sezione);
  }

  foundedAnagrafica(parte: Parte) {
    this.viewSearchMask = false;

    this.modaleAssociativaRicerca.inizializza(parte, this.addAltraParteUrl, this.idSezione, this.idFascicolo, this.urlSezioneControparti, this.idSezioneControparti);
  }
}
